import { Form, FormOptions } from "../PageBase";
import { generateName, getFormFields } from "../utils";
import { Client } from "./types";
import { FormField } from "../../../../actions/Tenants/config/constantsTyped";

interface ClientFormObject extends Omit<Client, "name" | "infos" | "fruit_types"> {
    fruit_type: string[];
    name?: string; // For display purposes in update forms
}

export const defineClientFormCreate = (onSaveClient: (client: Client) => void, onDeleteClient: (id: string) => void) => (formOptions: FormOptions | undefined, entity: Partial<Client> | undefined) => {
    const baseForm = getFormFields(formOptions, "Client");

    const nameField: FormField = {
        label: "Identifier",
        name: "name",
        type: "text",
        disabled: true,
    };

    const clientForm: FormField[] = entity?.id
        ? [nameField, ...baseForm]
        : baseForm;

    const onSave = (formObject: ClientFormObject, entity: Partial<Client>) => {
        const client: any = {
            ...entity,
            ...formObject,
            countries: formObject.countries ?? [],
            fruit_types: formObject.fruit_type,
            fruit_type: undefined,
            name: entity.name || generateName(formObject.label),
            infos: [...(entity.infos ?? [])]
        };

        onSaveClient(client as Client);
    };

    const onDelete = (_: ClientFormObject, entity: Partial<Client>) => {
        onDeleteClient(entity.id!);
    };

    const getFormObjectFromEntity = (entity: Partial<Client>): Partial<ClientFormObject> => {
        return {
            ...entity,
            countries: entity.countries ?? [],
            fruit_type: entity.fruit_types || [],
            name: entity.name,
        };
    };

    const clientModal: Form<ClientFormObject, Client> = {
        title: "Client",
        fields: clientForm,
        modalButtonLabel: "Edit",
        onSave,
        onDelete,
        getFormObjectFromEntity
    };

    return clientModal;
};
